import moment from 'moment';
import paginationComponent from '../../../components/pagination/pagination.component';
import SingleSelectComponent from '../../../components/single-select/single-select.component';
import { codeMasterType, formats } from '../../../config/constants';
import codeMasterModel from '../../../models/common/code-master.model';
import RawDataModel from '../../../models/raw-data/raw-data.model';
import UserRoleModel from '../../../models/user/user-role.model';
import ViewBase from '../../view-base.view';
import AddRawDataAccessDialog from './add-raw-data-access.dialog.view';

export default function RowDataAccess() {

  ViewBase.call(this);

  const SELECT_ALL_CHECKBOX_ID = 'deleteAccessSelectAllCheckbox';
  const CHECKBOX_NAME = 'deleteAccessCheckbox';

  const inputDataModel = {
    dataTypes: [],
    selectedDataType: {},
    templates: [],
    selectedTemplate: {},
    userTypes: [
      { name: 'User', code: "User" },
      { name: "User Role", code: "UserRole" }
    ],
    selectedUserType: {},
    userRoleOptionList: [],
    userId: [],
    selectedUserRole: {},
    dataTable: [],
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
  }

  let isAddAccessOpen = false;
  let selectedAccess = [];

  const requestBody = {
    get dataType() {
      return inputDataModel.selectedDataType.code
    },
    get template() {
      return inputDataModel.selectedTemplate.id
    },
    get userType() {
      return inputDataModel.selectedUserType.code
    },
    get userId() {
      return inputDataModel.userId;
    },
    get userRole() {
      return inputDataModel.selectedUserRole.code;
    },
    get pageIndex() {
      return inputDataModel.pageIndex
    },
    get pageSize() {
      return inputDataModel.pageSize
    }
  }

  const search = () => {
    this.showLoading();

    uncheckAllCheckboxes();
    RawDataModel.getRawDataAccessList(requestBody)
      .then((result) => {
        inputDataModel.dataTable = result.data;
        inputDataModel.totalCount = result.total;
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const onDelete = () => {
    this.showConfirm(this.getText('EM00000265', 'Are you sure you want to delete?'), '', (e) => {
      if (e === "YES") {
        RawDataModel.deleteRawDataAccess(selectedAccess.map(({ rawDataMasterId, user, userRole }) => {
          return { rawDataMasterId, userId: user, userRole }
        })).then((result) => {
          this.showMessage(this.getText('EM00000004', 'Success'), this.getText('EM00000004', 'Success'), () => {
            inputDataModel.pageIndex = 1;
            inputDataModel.pageSize = 10;
            uncheckAllCheckboxes();
            search();
          })
        }).catch((error) => {
          this.handleError(error);
        })
      }
    })
  }

  const getDataTypeList = () => {
    this.showLoading();
    codeMasterModel.getByCategoryV2({ category: codeMasterType.rawDataType })
      .then((result) => {
        if (result) {
          inputDataModel.dataTypes = result.map(({ name }) => ({ code: name, name }));
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getTemplateList = (dataType) => {
    this.showLoading();
    RawDataModel.getRawDataTemplateList(dataType)
      .then((result) => {
        if (result) {
          inputDataModel.templates = result;
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getUserRoleList = () => {
    UserRoleModel.getUserRoleList(
      (result) => {
        if (result) {
          inputDataModel.userRoleOptionList = result
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  const _initControls = () => {
    getDataTypeList();
  }

  const onCheckAll = (event) => {
    let checkboxes = document.querySelectorAll(`input[type='checkbox'][name='${CHECKBOX_NAME}']`);

    selectedAccess = [];

    if (event.target.checked || event.target.indeterminate) {
      inputDataModel.dataTable.forEach((item) => {
        selectedAccess.push(item);
      });

      checkboxes.forEach((item) => {
        item.checked = true;
      });
    } else {
      checkboxes.forEach((item) => {
        item.checked = false;
      });
    }
    event.target.indeterminate = false;
  };

  const selectRow = (checked, item) => {
    if (checked) {
      selectedAccess.push(item);
    } else {
      selectedAccess = selectedAccess.filter((data) => data.userId !== item.userId || data.userRole !== item.userRole || data.rawDataMasterId !== item.rawDataMasterId);
    }

    let selectAllCheckbox = document.querySelector(`#${SELECT_ALL_CHECKBOX_ID}`);
    if (selectedAccess.length === 0) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = false;
    }
    else if (selectedAccess.length === inputDataModel.dataTable.length) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = true;
    } else {
      selectAllCheckbox.indeterminate = true;
      selectAllCheckbox.checked = false;
    }
  };

  const uncheckAllCheckboxes = () => {
    const checboxes = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
    if (checboxes.length == 0) {
      return;
    }
    checboxes.forEach((checkbox) => {
      checkbox.checked = false;
    })
    let selectAllCheckbox = document.querySelector(`#${SELECT_ALL_CHECKBOX_ID}`);
    selectAllCheckbox.indeterminate = false;
    selectAllCheckbox.checked = false;

    selectedAccess = [];
  }
  return {
    oninit: () => {
      _initControls();
    },
    view: () => {
      return [
        m('.row',
          m('.col-12',
            m('.card.mb-3',
              m('.card-body',
                m('form.row.g-4.align-items-end.needs-validation[novalidate]',
                  {
                    onsubmit: (e) => {
                      e.preventDefault();
                      inputDataModel.pageIndex = 1;
                      inputDataModel.pageSize = 10;
                      search();
                    }
                  },
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label[for="dataType"]', this.getText("LT00000013", "Data Type")
                    ),
                    m(SingleSelectComponent, {
                      id: 'dataType',
                      items: inputDataModel.dataTypes,
                      selectedItem: inputDataModel.selectedDataType,
                      onSelect: (selectedItem) => {
                        inputDataModel.selectedDataType = selectedItem;
                        if (selectedItem.code) {
                          getTemplateList(selectedItem.code)
                        }
                        if (inputDataModel.selectedTemplate.id) {
                          inputDataModel.selectedTemplate = {}
                        }
                      }
                    })
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label[for=template]', this.getText("LT00000202", "Template")
                    ),
                    m(SingleSelectComponent, {
                      id: 'template',
                      itemKey: 'id',
                      disabled: inputDataModel.selectedDataType?.code ? false : true,
                      items: inputDataModel.templates,
                      selectedItem: inputDataModel.selectedTemplate,
                      onSelect: (selectedItem) => {
                        inputDataModel.selectedTemplate = selectedItem;
                      }
                    })
                  ),
                  m('.col-xl-3.col-lg-4.col-md-6.position-relative',
                    m('label.form-label[for=userType]', this.getText("LT00000193", "User Type")),
                    m(SingleSelectComponent, {
                      id: 'userType',
                      allowEmpty: true,
                      items: inputDataModel.userTypes,
                      selectedItem: inputDataModel.selectedUserType,
                      onSelect: (selectedItem) => {
                        inputDataModel.selectedUserType = selectedItem;
                        if (selectedItem.code === "UserRole") {
                          inputDataModel.userId = ''
                          getUserRoleList()
                        } else {
                          inputDataModel.selectedUserRole = []
                        }
                      }
                    }),
                    m('.invalid-tooltip', this.getText("EM00000818", "Please select a template")),
                  ),
                  inputDataModel.selectedUserType?.code === 'UserRole' &&
                  m('.col-xl-3.col-lg-4.col-md-6.position-relative',
                    m('label.form-label[for=userRole]', this.getText("LT00000060", "User Role")),
                    m(SingleSelectComponent, {
                      id: 'userRole',
                      disabled: inputDataModel.selectedUserType?.code ? false : true,
                      items: inputDataModel.userRoleOptionList,
                      selectedItem: inputDataModel.selectedUserRole,
                      onSelect: (s) => {
                        inputDataModel.selectedUserRole = s;
                      }
                    }),
                    m('.invalid-tooltip', this.getText("EM00000291", "User Role required.")),
                  ),
                  inputDataModel.selectedUserType?.code === 'User' &&
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label[for=userId]', this.getText("LT00000049", "User ID")),
                    m('input.form-control[type=text]', {
                      placeholder: this.getText("LT00000049", "User ID"),
                      maxLength: 100,
                      onchange: (e) => {
                        inputDataModel.userId = e.target.value;
                      }
                    },
                    ),
                    m('.invalid-tooltip', this.getText("EM00000818", "Please select a template")),
                  ),

                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary[type="submit"]', {
                    }, this.getText("LT00000001", "Search")),
                  ),
                ),
              ),
            )
          ),
          m('.col-12',
            m('.card.mb-3',
              m('.card-body',
                m('.row',
                  m('.col-12.d-flex.justify-content-end.pb-2.gap-2',
                    selectedAccess.length > 0 &&
                    m('button.btn.btn-danger',
                      {
                        onclick: onDelete
                      },
                      this.getText('LT00001192', 'Delete Access')
                    ),
                    m('button.btn.btn-primary',
                      {
                        onclick: () => { isAddAccessOpen = true; }
                      },
                      this.getText('LT00001193', 'Add Access')
                    )
                  ),
                  m('.col-12',
                    m('.table-responsive',
                      m('table.table.table-hover.sticky-column-start',
                        m('thead',
                          m('tr.align-middle',
                            m('th[scope="col"]',
                              m('input', {
                                tabindex: -1,
                                id: SELECT_ALL_CHECKBOX_ID,
                                type: 'checkbox',
                                onchange: onCheckAll
                              })
                            ),
                            m('th[scope="col"]', this.getText('LT00000009', 'User')),
                            m('th[scope="col"]', this.getText('LT00000060', 'User Role')),
                            m('th[scope="col"]', this.getText('LT00000013', 'Data Type')),
                            m('th[scope="col"]', this.getText('LT00000202', 'Template')),
                            m('th[scope="col"]', this.getText('LT00000041', 'Create Date')),

                          )
                        ),
                        m('tbody',
                          (inputDataModel.dataTable.length == 0) &&
                          m('tr.align-middle',
                            m('td[colSpan=6]', this.getText("EM00000141", "No records found."))
                          ),
                          inputDataModel.dataTable.length > 0 &&
                          inputDataModel.dataTable.map((data, index) =>
                            m('tr.align-middle',
                              m('td',
                                m('input', {
                                  id: `${CHECKBOX_NAME}${index}`,
                                  type: 'checkbox',
                                  tabindex: -1,
                                  name: CHECKBOX_NAME,
                                  onchange: (event) => { selectRow(event.target.checked, data); }
                                })
                              ),
                              m('td', m('span.cursor-text', data.user || 'N/A')),
                              m('td', m('span.cursor-text', data.userRole || 'N/A')),
                              m('td', m('span.cursor-text', data.dataType)),
                              m('td', m('span.cursor-text', data.name)),
                              m('td', m('span.cursor-text', moment(data.createDate).format(formats.LOCAL_TIME)))
                            )
                          )
                        )
                      )
                    ),
                    inputDataModel.dataTable.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: inputDataModel.pageIndex,
                        pageSize: inputDataModel.pageSize,
                        totalItems: inputDataModel.totalCount,
                        onPageChanged: (pageIndex) => {
                          inputDataModel.pageIndex = pageIndex;
                          search();
                        },
                        onPageSizeChanged: (pageIndex, pageSize) => {
                          inputDataModel.pageIndex = pageIndex;
                          inputDataModel.pageSize = pageSize;
                          search();
                        }
                      })
                    )
                  )
                )
              )
            )
          ),
          m(AddRawDataAccessDialog, {
            isOpen: isAddAccessOpen,
            onClose: (needReload) => {
              isAddAccessOpen = false;
              if (needReload === true) {
                search();
              }
            }
          }),

        ),
        this.getBaseViews()
      ]
    }
  }
}
